import { type ObjectContent, type ListContentOf, type CardContent, type ContentComponent } from '../../../../types/construct.types';

export interface GroupItemsSectionContent extends ObjectContent {
	fields: {
		group_items: ListContentOf<CardContent>;
	};
}

export const GroupItemsSection: ContentComponent<GroupItemsSectionContent> = ({ content, renderer }) => (
	<div className="flex flex-wrap items-start">
		{content.fields.group_items.items.map((item, itemIndex) =>
			renderer.render(item, itemIndex, { GroupItemContent: { totalItemCount: content.fields.group_items.items.length } })
		)}
	</div>
);
